<template>
  <div class="wrapper-card">
    <div class="badge-information p-2 price">
      <span class="icon"><img src="/assets/img/after-booking-icon1.png" alt="after-booking-icon" title="" /></span>
      {{ $t("booking.total-to-pay") }} : <strong>₪{{ price }}</strong>
    </div>
    <div style="min-height:180px; text-align:center;">
      <iframe id="verifyingCard" title="Card Verifying" :src="path1" v-show="loaded"></iframe>
      <img src="/assets/img/iframe-swimming-loading.gif" class="loading-gif" v-if="!loaded" alt="iframe-swimming-loading"/>
    </div>

    <b-modal id="failCardVerifyModal" centered size="lg" dir="rtl" :no-close-on-backdrop="true" :ok-only="true">
      <template #modal-header="{}">
        <div class="d-flex flex-grow-1 align-items-baseline text-right" >
          <h3 class="m-auto">{{ $t("booking.notice") }}</h3>
          <h5>{{ maxSec }} {{ $t("booking.sec") }}</h5>
        </div>
      </template>
      <template>
        <p class='text-right'>{{ $t("redirect.no-fill-card") }}</p>
      </template>
      <template #modal-footer="{ ok }">
        <b-button size="lg" variant="success" @click="gotoBookingPage(); ok();">
          {{ $t("booking.ok") }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { fromBase64 } from '@/utils/base64Util';
import disableBackForward from '@/mixins/disableBackForward';

export default {
  mixins: [disableBackForward],
  data() {
    return {
      loaded: false,
      product: null,
      path1: '',
      maxSec: 3 * 60,
      timeIntervalID: null,
      timeoutID: null,
      onloadCount: 0,
      lastOnloadAt: 0,
      recoveryIntervalID: null,
      recoveryAttempted: false,
    };
  },
  computed: {
    ...mapGetters({
      lang: 'GET_LANGUAGE',
      path: 'GET_VERIFYING_URL',
      bookingDataID: 'GET_BOOKING_DATA_ID',
      marketerId: 'GET_MARKETER_ID',
      subMarketerId: 'GET_SUB_AGENCY',
      isOdysseySite: 'GET_ODYSSEY_AGENT_STATE',
      agencyOwnerName: 'GET_AGENCY_OWNER_NAME',
      affiliation: 'GET_AFFILIATION',
      isDirectPayment: 'GET_DIRECT_PAYMENT_STATE',
      isLoginMarketer: 'GET_IS_LOGIN_MARKETER',
      usePaxBankCreditAsLoginCredential: 'GET_USE_PAX_BANK_CREDIT_AS_LOGIN_CREDENTIAL',
      debitAmountInCreditCard: 'GET_DEBIT_AMOUNT_IN_CREDICARD',
    }),
    price() {
      if(!this.product) return 0;

      if (this.usePaxBankCreditAsLoginCredential && this.debitAmountInCreditCard > 0) {
        return this.debitAmountInCreditCard;
      }

      return this.product.grandTotalAfterDiscount;
    }
  },
  created() {
    this.path1 = this.path || window.localStorage.getItem('VERIFYING_URL');
    window.localStorage.setItem('VERIFYING_URL', this.path1);
    if (document.querySelector('.st-content'))document.querySelector('.st-content').scrollTo(0, 0);

    this.product = JSON.parse(fromBase64(window.localStorage.getItem('BookingDetailInfo'))).data;
    const { marketerId, subMarketerId } = this;
    window.localStorage.setItem('marketer', JSON.stringify({ marketerId, subMarketerId }));
    this.$store.dispatch('FETCH_MARKETER_CREDIT_AMOUNT', { currency: 'IS' });
  },
  unmounted() {
    window.removeEventListener('popstate');
    window.clearInterval(this.timeIntervalID);
    window.clearTimeout(this.timeoutID);
    window.clearInterval(this.recoveryIntervalID);
  },
  beforeDestroy() {
    window.clearInterval(this.recoveryIntervalID);
  },
  mounted() {
    const that = this;
    document.getElementById('verifyingCard').onload = () => {
      that.onloadCount += 1;
      that.lastOnloadAt = Date.now();
      if (that.onloadCount === 1) {
        that.loaded = true;
        that.afterIframeLoaded();
      }
      that.tryFollowIframeIntoTop();
    };

    // Note: an earlier version auto-fired recovery (payAndBook + redirect) when
    // Pelecard's 3DS landing page got stuck. That created a loop with
    // BookingHotel.vue's retryState auto-resume (readOnly=true → availableUsers
    // → auto-fire GET_PAYMENT_URL → back to verifying-card → blocked 3DS → loop).
    // The auto-fire was removed; tryFollowIframeIntoTop still runs from onload as
    // a one-way safety net for cases where Pelecard does redirect inside the
    // iframe to our bridge route (no loop risk — only fires on same-origin URL).

    if (!this.isOdysseySite) {
      const bookingDataID = this.bookingDataID || window.localStorage.getItem('BookingDataID'),
        { hotel: { hotelName, cityName, checkinDate, checkoutDate }, priceBeforeCoupon } = this.product;
      const storedAgencyOwnerName = JSON.parse(fromBase64(window.sessionStorage.getItem('agencyOwner') || ''));
      const name = `${hotelName} - ${cityName} - ${storedAgencyOwnerName || this.agencyOwnerName}`;

      this.$store.dispatch('SENDING_GA_EVENT', {
        eventName: 'begin_checkout',
        currency: 'ILS',
        value: priceBeforeCoupon,
        items: [
          {
            item_id: bookingDataID,
            item_name: name,
            affiliation: this.affiliation,
            item_category: cityName,
            item_category2: `${checkinDate} - ${checkoutDate}`,
            price: priceBeforeCoupon,
          },
        ],
      });
      // window.gtag('event', 'begin_checkout', {
      //   currency: 'ILS',
      //   value: priceBeforeCoupon,
      //   items: [
      //     {
      //       item_id: bookingDataID,
      //       item_name: name,
      //       affiliation: this.affiliation,
      //       coupon: '',
      //       discount: '',
      //       index: 0,
      //       item_brand: '',
      //       item_category: cityName,
      //       item_category2: `${checkinDate} - ${checkoutDate}`,
      //       item_category3: '',
      //       item_category4: '',
      //       item_category5: '',
      //       item_list_id: '',
      //       item_list_name: '',
      //       item_variant: '',
      //       location_id: '',
      //       price: priceBeforeCoupon,
      //       quantity: 1,
      //     },
      //   ],
      // });

      this.$store.dispatch('JOURNEY_OPEN_CARD_PAGE');
    }

    window.addEventListener('popstate', () => {
      const isDirectPaymentState = window.localStorage.getItem('direct-payment') === 'true';
      if (isDirectPaymentState) this.$store.dispatch('GET_BOOKED_INFO', { isDirect: isDirectPaymentState });
    });
  },
  methods: {
    tryFollowIframeIntoTop() {
      const iframe = document.getElementById('verifyingCard');
      if (!iframe) return false;
      let href = null;
      try {
        href = iframe.contentWindow.location.href;
      } catch (e) {
        return false; // cross-origin: Pelecard still owns the iframe
      }
      if (!href || href === 'about:blank') return false;
      if (!/\/fail-card-verified|\/redirect-verified|\/booking\/card-verified/.test(href)) return false;
      window.clearInterval(this.recoveryIntervalID);
      window.clearTimeout(this.timeoutID);
      window.location.replace(href);
      return true;
    },
    async finalizeBookingFromStuckIframe() {
      window.clearInterval(this.recoveryIntervalID);
      window.clearTimeout(this.timeoutID);
      try {
        const res = await this.$store.dispatch('GET_BOOKED_INFO', { isDirect: this.isDirectPayment });
        const data = (res && res.data) ? res.data : {};
        const statusCode = data.status ? Number(data.status.code) : null;
        const errorObj = data.error || {};
        if ([10, 11, 8].includes(statusCode)) {
          window.location.replace(`/booking/card-verified?lang=${this.lang}`);
          return;
        }
        window.localStorage.setItem('retryState', JSON.stringify({
          readOnly: !!errorObj.retryAllowed,
          cardFailed: true,
        }));
        if (this.isDirectPayment) {
          window.location.replace('/personal-area');
          return;
        }
        let url = '/booking/hotel?';
        if (this.marketerId) url += `marketerId=${this.marketerId}&`;
        url += `lang=${this.lang}`;
        window.location.replace(url);
      } catch (e) {
        this.recoveryAttempted = false;
      }
    },
    afterIframeLoaded() {
      // const { host } = window.location;
      // if (host.includes('localhost') || host.includes('vercel')) {
      //   this.timeoutID = setTimeout(() => {
      //     window.location.href = '/fail-card-verified';
      //   }, 1000 * 60 * 5);
      // }

      this.timeoutID = setTimeout(() => {
        this.showTimeFailedModal();
      }, 10 * 60 * 1000);

      // const { payer } = this.product;
      // const { identificationNumber, creditCardExpirMonth, creditCardExpirYear, noOfPayment } = payer;
      // const iframe = document.getElementById('verifyingCard');
      // const innerDoc = iframe.contentDocument || iframe.contentWindow.document;
      // innerDoc.getElementById('paymentByCC').innerHtml = 'תשלום באמצעות כרטיס אשראי';
      // innerDoc.getElementById('credit_card_number_input').values = '375510290006779';
      // innerDoc.getElementById('date_year_input').value = creditCardExpirMonth;
      // innerDoc.getElementById('date_month_input').value = creditCardExpirYear;
      // innerDoc.getElementById('id_number_input').value = identificationNumber;
      // innerDoc.getElementById('cvv_input').value = noOfPayment;
    },
    showTimeFailedModal() {
      window.localStorage.setItem('retryState', JSON.stringify({ readOnly: true }));
      this.$bvModal.show('failCardVerifyModal');
      this.timeIntervalID = setInterval(() => {
        this.maxSec -= 1;
        if (this.maxSec === 0) {
          this.gotoBookingPage();
        }
      }, 1000);
    },
    async gotoBookingPage() {
      this.$bvModal.hide('failCardVerifyModal');

      // call the action to inform to backedend that booking is done
      const res = await this.$store.dispatch('GET_BOOKED_INFO', { isDirect: this.isDirectPayment });
      window.localStorage.setItem('retryState', JSON.stringify({
        readOnly: res.data.error.retryAllowed,
        cardFailed: true,
      }));

      // goto booking page
      if (this.isDirectPayment) {
        this.$router.push({ path: '/personal-area' });
      } else {
        let url = '/booking/hotel';
        if (this.marketerId) {
          url += `?marketerId=${this.marketerId}&lang=${this.lang}`;
        } else {
          url += `?lang=${this.lang}`;
        }
        window.parent.location.href = url;
      }
    },
  },
};
</script>

<style scoped>

  #verifyingCard{
    width: 100%;
    height: 670px;
    border: none;
  }

  .wrapper-card{
    margin : auto;
    width: 100%;
    height: 100%;
  }

  .price{
    font-size : 30px;
  }
  .loading-gif {
    max-width: 100px;
    text-align: center;
    margin-top: 50px;
  }
</style>
